import {
  GenericHeader,
  NavigationBarWrapper,
  Profile,
  LoginExpireModal,
  Login,
  RegisterPage,
  ResetPassword,
  ResetPasswordPage,
  userPreference,
  getApplicationFeatures,
  featureList,
  getAppContextRoute,
  getDefaultModuleroute,
  getSystemSettings,
  getUserSettings,
  intializeModuleFunctions,
} from "@brightinsight/bi-web-dms-modules";
 import {Patients} from "./modules/patients";

const exportsObject = {
  GenericHeader,
  NavigationBarWrapper,
  Profile,
  LoginExpireModal,
  Login,
  RegisterPage,
  ResetPassword,
  ResetPasswordPage,
  userPreference,
  getApplicationFeatures,
  featureList,
  getAppContextRoute,
  getDefaultModuleroute,
  getSystemSettings,
  getUserSettings,
  intializeModuleFunctions,
  Patients,
};

import React from "react";
import { createRoot } from "react-dom/client";
import { RenderAppWithTheme, loadAppTheme } from '@brightinsight/bi-web-portal-base';

// Get the root element where the app will be rendered
const rootElement = document.getElementById("care-team-portal");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(rootElement!);


const renderAppWithTheme = (theme: object) => {
  root.render(
    <RenderAppWithTheme {...theme} />
  );
};

const initializeAppTheme = async () => {
  const theme:any = await loadAppTheme(exportsObject);
  console.log(theme)
  renderAppWithTheme(theme)

}

initializeAppTheme()

